module.exports = __webpack_public_path__ + "static/helvetica-neue-light-afc80fd38b63916e55b3434d6dc50aa8.woff";